import { create } from "zustand";

type State = {
  visibleHeaderPixels: number;
};

export const useLayoutStore = create<State>(() => ({
  visibleHeaderPixels: 0,
}));

export const setVisibleHeaderPixels = (pixels: number) => {
  useLayoutStore.setState({ visibleHeaderPixels: pixels });
};
